import { getAccountsResponse } from '@shared/api/rest/accounts';
import { AmountUtils, CurrencyUtils } from '@shared/utils';
import { ButtonV2 } from '@shared/widgets';
import { Dispatch } from 'react';

interface AccountSlideItemType {
  account: getAccountsResponse;
  setSlideAccount: Dispatch<React.SetStateAction<getAccountsResponse | undefined>>;
  setIsVisibleTopModal: Dispatch<React.SetStateAction<boolean>>;
}

export const AccountSlideItem = (props: AccountSlideItemType) => {
  const onTopUp = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    props.setSlideAccount(props.account);
    props.setIsVisibleTopModal(true);
  };

  return (
    <>
      <div className='absolute top-0 left-0 z-2 h-full w-full rotate-y-0 duration-300 backface-hidden hover:scale-95'>
        <div className='background-image front-position relative flex h-full rounded shadow-[12px_12px_24px_0_rgba(0,0,0,0.23)] duration-100 hover:scale-95' />
        <div className='absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center text-4xl font-bold text-[#f2f2f2] not-lg:text-3xl'>
          <div className='mr-1'>{CurrencyUtils.getSymbolByCode(props.account.Currency)}</div>
          <div className='uppercase'>{props.account.Currency}</div>
        </div>
      </div>
      <div className='absolute top-0 left-0 h-full w-full rotate-y-180 backface-hidden'>
        <div className='background-image back-position relative flex h-full items-center justify-center rounded shadow-[12px_12px_24px_0_rgba(0,0,0,0.23)]'>
          <div className='text-white'>
            <div className='mb-4 flex items-center justify-start text-xl not-lg:mb-1 not-lg:text-lg'>
              <div className='mr-1'>{CurrencyUtils.getSymbolByCode(props.account.Currency)}</div>
              <div className='uppercase'>{props.account.Currency}</div>
            </div>
            <div className='text-4xl font-bold not-lg:text-3xl'>{AmountUtils.transformToAmount(props.account.Amount)}</div>
          </div>
          <div className='absolute right-5 bottom-6 h-12 w-[96px] not-lg:h-8 not-lg:w-[68px]'>
            <ButtonV2 fullWidth onClick={(e?: React.MouseEvent<HTMLButtonElement>) => onTopUp(e!)}>
              Top up
            </ButtonV2>
          </div>
        </div>
      </div>
    </>
  );
};
